<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>

    <div :class="{'has-error':errors.creditType}">
      <select v-model="selectedCreditType" name="creditType" class="form-control" @input="handleChange">
        <option value="">Select One</option>
        <option value="amount">Amount</option>
        <option value="variable">Another variable's value</option>
      </select>
    </div>

    <div v-if="selectedCreditType === 'amount'" :class="{'has-error':errors.creditamount}">
      Credit $<input
        v-model="creditamount"
        name="creditamount"
        class="form-control input-numeric"
        @input="handleChange"
      >
      to account
    </div>
    <div v-else-if="selectedCreditType === 'variable'" :class="{'has-error':errors.variableId}">
      <select v-model="variableId" name="variableId" class="form-control" @input="handleChange">
        <option value="">Select One</option>
        <option v-for="(studyVariable) in this.numericVariables" :value="studyVariable.id">
          {{ studyVariable.name }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

export default {
  extends: BaseComponent,
  props: {
    // Fundamentally a number, but often stored as a string
    creditamount: [Number, String],
    variableId: [Number, String],
    creditType: {
      type: String,
      default: 'amount',
    },
    id: String
  },
  data() {
    return {
      numericVariables: this.filterStudyVariables(),
      selectedCreditType: this.creditType,
    }
  },
  methods: {
    filterStudyVariables: function () {
      let filtered = [];

      Object.keys(this.config.studyVariables).forEach((key, idx) => {
        let variable = this.config.studyVariables[key];
        if (variable.is_numeric) {
          filtered.push(variable);
        }
      });
      return filtered;
    },
    validate: function () {
      this.errors = {};

      switch (this.creditType) {
        case 'amount':
          if (!this.isNumber(this.creditamount) || this.creditamount < 0) {
            this.errors.creditamount = "Please enter a credit amount.";
          }
          break;
        case 'variable':
          if (!this.isNumber(this.variableId)) {
            this.errors.variableId = "Please select a variable.";
          }
          break;
        default:
          this.errors.creditType = "Please select 'Amount' or 'Another variable's value'";
          break;
      }
      return Object.keys(this.errors).length === 0;
    }
  }
};
</script>
